module.exports = __webpack_public_path__ + "img/8.c93f31d5.webp";